import { NavigationAction } from 'src/modules/navigation/actions/navigationActions';
import { ProgramsAction } from 'src/modules/programs/actions/programsActions';
import { CPProgramAction } from 'src/modules/programs/cpProgram/actions/cpProgramActions';
import { FeedbackAction } from 'src/modules/programs/feedback/actions/feedbackActions';
import { SurveysAction } from 'src/modules/programs/surveys/actions/surveysActions';
import { VideosAction } from 'src/modules/videos/actions/videosActions';
import { SharedAction } from 'src/shared/actions/sharedActions';

export interface Action<T, P = null> {
    readonly type: T;
    readonly payload: P;
}

// LEGACY: TO BE REMOVED WHEN MIGRATION FROM REDUX-OBSERVABLES TO REDUX-REMATCH FINISHED
export type AppAction =
    | NavigationAction
    | SharedAction
    | ProgramsAction
    | SurveysAction
    | FeedbackAction
    | CPProgramAction
    | VideosAction;

export function creator<A extends Action<T, null>, T extends AppAction['type'] = A['type']>(
    type: T,
    enhancer?: (action: A) => A,
): () => A;

export function creator<
    A extends Action<T, P>,
    T extends AppAction['type'] = A['type'],
    P = A['payload']
>(type: T, enhancer?: (action: A) => A): (payload: P) => A;

export function creator<
    A extends Action<T, P>,
    T extends AppAction['type'] = A['type'],
    P = A['payload']
>(type: T, enhancer: (action: A) => A = a => a): (payload?: P) => A {
    return (payload: P | null = null): A => {
        return enhancer({
            payload,
            type,
        } as A);
    };
}
